/**
 * main-store-section.js
 *
 * Hydrates the per-store rating chip and the "What customers say on
 * Google" list from the dashboard's snapshot endpoint.
 *
 * Why client-side fetch instead of Liquid metafields?
 *   The snapshot is refreshed daily by Laravel, but the storefront
 *   pages are heavily cached. A small JSON fetch (response is cached
 *   30 min server-side) is the cheapest way to keep the rating fresh
 *   without invalidating the entire page cache.
 */
(function () {
  'use strict';

  var ENDPOINT = '/apps/coin-rewards/public/locations/google-reviews';

  var ratingNodes = document.querySelectorAll('[data-google-rating]');
  var reviewNodes = document.querySelectorAll('[data-google-reviews]');

  if (!ratingNodes.length && !reviewNodes.length) return;

  function escapeHtml(s) {
    if (s == null) return '';
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  // Render N filled stars + (5-N) empty stars. Uses inline SVG so we
  // don't have to ship icon fonts or bring in a star widget library.
  function renderStars(rating) {
    var n = Math.round(Number(rating) || 0);
    var html = '';
    for (var i = 1; i <= 5; i++) {
      var filled = i <= n;
      html +=
        '<svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true">' +
        '<path fill="' + (filled ? '#FBBC05' : '#dadada') + '" d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01z"/>' +
        '</svg>';
    }
    return html;
  }

  function fillRating(node, snap) {
    if (!snap || snap.rating == null) return;

    var stars = node.querySelector('[data-rating-stars]');
    var value = node.querySelector('[data-rating-value]');
    var count = node.querySelector('[data-rating-count]');

    if (stars) stars.innerHTML = renderStars(snap.rating);
    if (value) value.textContent = Number(snap.rating).toFixed(1);
    if (count && snap.user_ratings_total != null) {
      count.textContent = '(' + snap.user_ratings_total + ' reviews)';
    }
    if (snap.url) node.setAttribute('href', snap.url);

    node.classList.remove('is-loading');
    node.removeAttribute('hidden');
  }

  function fillReviews(node, snap) {
    if (!snap || !snap.reviews || !snap.reviews.length) return;

    var list = node.querySelector('[data-reviews-list]');
    if (!list) return;

    list.innerHTML = snap.reviews
      .map(function (r) {
        // Truncate review text — Google sends long ones and the card
        // gets unwieldy. Keep the first ~180 chars + ellipsis.
        var text = r.text || '';
        if (text.length > 180) text = text.slice(0, 177).trim() + '…';

        var photo = r.profile_photo_url
          ? '<img class="main-store-section__review-avatar" src="' +
            escapeHtml(r.profile_photo_url) +
            '" alt="" loading="lazy" />'
          : '<span class="main-store-section__review-avatar main-store-section__review-avatar--placeholder">' +
            escapeHtml((r.author_name || '?').charAt(0).toUpperCase()) +
            '</span>';

        return (
          '<li class="main-store-section__review">' +
          '<div class="main-store-section__review-head">' +
          photo +
          '<div class="main-store-section__review-meta">' +
          '<span class="main-store-section__review-name">' + escapeHtml(r.author_name || 'Customer') + '</span>' +
          '<span class="main-store-section__review-stars">' + renderStars(r.rating) + '</span>' +
          (r.relative_time_description
            ? '<span class="main-store-section__review-time">' + escapeHtml(r.relative_time_description) + '</span>'
            : '') +
          '</div>' +
          '</div>' +
          (text ? '<p class="main-store-section__review-text">' + escapeHtml(text) + '</p>' : '') +
          '</li>'
        );
      })
      .join('');

    node.removeAttribute('hidden');
  }

  fetch(ENDPOINT, { headers: { Accept: 'application/json' } })
    .then(function (r) {
      if (!r.ok) throw new Error('snapshot http ' + r.status);
      return r.json();
    })
    .then(function (json) {
      var byslug = (json && json.locations) || {};

      ratingNodes.forEach(function (node) {
        fillRating(node, byslug[node.getAttribute('data-google-rating')]);
      });
      reviewNodes.forEach(function (node) {
        fillReviews(node, byslug[node.getAttribute('data-google-reviews')]);
      });
    })
    .catch(function () {
      // Snapshot not yet seeded or proxy down. Don't show empty
      // skeletons — leave the placeholders hidden as Liquid set them.
    });
})();
